import {ChangeDetectionStrategy, Component, computed, inject, Input} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {TypedForm, TypedFormOwnControls} from '../../../common/form-types';
import {DexMdSubjectService} from '../../../components/dex/dex-streaming/subjects/dex-md-subject-service';
import {
    DexSecuritiesSubjectService
} from '../../../components/dex/dex-streaming/subjects/dex-securities-subject-service';
import {SelectItem} from '../../../components/select-input/select-item';
import {WidgetImplSettingsComponentBase} from '../../components/widget-impl-settings-component-base';
import {DexTrancheDetailsWidget} from '../dex-tranche-details-widget';
import {DexTrancheDetailsWidgetSettings} from './dex-tranche-details-widget-settings';

interface SettingsFormValue {
    title: string;
    trancheSymbol: string;
}

@Component({
    selector:    'dex-tranche-details-widget-settings',
    templateUrl: './dex-tranche-details-widget-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone:  false
})
export class DexTrancheDetailsWidgetSettingsComponent extends WidgetImplSettingsComponentBase<DexTrancheDetailsWidget> {

    @Input()
    public override widget: DexTrancheDetailsWidget;

    public form: TypedForm<SettingsFormValue>;

    public readonly dexMdSubjectService = inject(DexMdSubjectService);
    public readonly dexSecuritiesSubjectService = inject(DexSecuritiesSubjectService);

    public readonly $trancheSymbolSelectItems = computed<Array<SelectItem<string>>>(() => {
        const tranches = this.dexMdSubjectService.$traches();

        return tranches.map(tr => {
            const d = this.dexSecuritiesSubjectService.getDeliverableById(tr.unitDeliverableId);

            return {
                value: d?.symbol || undefined,
                label: `${d?.symbol} - ${tr.name}`
            } satisfies SelectItem<string>;
        });
    });

    protected override buildForm(): void {
        const settings: DexTrancheDetailsWidgetSettings = this.widget.implementationInstance.settings;

        const controls: TypedFormOwnControls<SettingsFormValue> = {
            title:         this.createTitleFormControl(settings),
            trancheSymbol: new FormControl<string>(settings.symbol)
        };

        this.bindControlToSettings({control: controls.trancheSymbol, settingsFieldName: 'symbol'});

        this.form = new FormGroup(controls) as TypedForm<SettingsFormValue>;
    }

}
